"use client";

import { ArrowLeft } from "lucide-react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { SignInForm } from "../forms/sign-in-form";

export function SignInView() {
  const router = useRouter();

  const handleSuccess = () => {
    toast.success("Login realizado com sucesso!");
    router.push("/dashboard");
  };

  const handleError = (error: any) => {
    toast.error(error?.message?.[0] || "Erro ao fazer login.");
  };

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-md">
        <div className="flex flex-col gap-4">
          <div className="absolute top-8 left-8 opacity-95">
            <Link
              href="/"
              className="flex items-center gap-2 text-sm text-black/70 dark:text-white/70 hover:text-black dark:hover:text-white transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              Volta para início
            </Link>
          </div>

          <SignInForm onSuccess={handleSuccess} onError={handleError} />
        </div>
      </div>
    </div>
  );
}
